export default __webpack_public_path__ + "static/media/vredesstad-ieper.394469ba.png";